import { useSyncExternalStore } from 'use-sync-external-store/shim';
var emptySubscribe = function() {
    return function() {};
};
var clientSnapshot = function() {
    return false;
};
var serverSnapshot = function() {
    return true;
};
export var useIsSSR = function() {
    return useSyncExternalStore(emptySubscribe, clientSnapshot, serverSnapshot);
};
